import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import reactDom from 'react-dom';
import styled, { css } from 'styled-components';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var noScroll = createCommonjsModule(function (module) {
(function(root) {
  var isOn = false;
  var scrollbarSize;
  var scrollTop;

  function getScrollbarSize() {
    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

    var doc = document.documentElement;
    var dummyScroller = document.createElement('div');
    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
    doc.appendChild(dummyScroller);
    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
    doc.removeChild(dummyScroller);
    return scrollbarSize;
  }

  function hasScrollbar() {
    return document.documentElement.scrollHeight > window.innerHeight;
  }

  function on(options) {
    if (typeof document === 'undefined' || isOn) return;
    var doc = document.documentElement;
    scrollTop = window.pageYOffset;
    if (hasScrollbar()) {
      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
    } else {
      doc.style.width = '100%';
    }
    doc.style.position = 'fixed';
    doc.style.top = -scrollTop + 'px';
    doc.style.overflow = 'hidden';
    isOn = true;
  }

  function off() {
    if (typeof document === 'undefined' || !isOn) return;
    var doc = document.documentElement;
    doc.style.width = '';
    doc.style.position = '';
    doc.style.top = '';
    doc.style.overflow = '';
    window.scroll(0, scrollTop);
    isOn = false;
  }

  function toggle() {
    if (isOn) {
      off();
      return;
    }
    on();
  }

  var noScroll = {
    on: on,
    off: off,
    toggle: toggle,
  };

  {
    module.exports = noScroll;
  }
})(commonjsGlobal);
});

var portal = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();





var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactDom2 = _interopRequireDefault(reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var useCreatePortal = typeof _reactDom2.default.createPortal === 'function';
var isBrowser = typeof window !== 'undefined';

var Portal = function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (isBrowser) {
        if (!this.props.container) {
          this.container = document.createElement('div');
          document.body.appendChild(this.container);
        } else {
          this.container = this.props.container;
        }
        this.renderLayer();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!useCreatePortal) {
        _reactDom2.default.unmountComponentAtNode(this.container);
      }
      if (!this.props.container) {
        document.body.removeChild(this.container);
      }
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer() {
      if (!useCreatePortal) {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (useCreatePortal) {
        return _reactDom2.default.createPortal(this.props.children, this.container);
      }
      return null;
    }
  }]);

  return Portal;
}(React.Component);

Portal.propTypes = {
  children: _propTypes2.default.node, // eslint-disable-line
  container: _propTypes2.default.object // eslint-disable-line
};

exports.default = Portal;
});

var Portal = unwrapExports(portal);

var srcShape = PropTypes.shape({
  url: PropTypes.string.isRequired,
  thumb: PropTypes.string
}).isRequired;

var srcArray = PropTypes.arrayOf(srcShape).isRequired;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  top: 50%;\n  transform: translateY(-50%);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  left: 50%;\n  transform: translateX(-50%);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var horizontalAlignment = css(_templateObject());
var verticalAlignment = css(_templateObject2());
var bothAlignments = css(_templateObject3());

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var hideScroll = css(_templateObject$2());

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  border: none;\n  border-radius: 0;\n  background: none;\n  margin: 0;\n  padding: 0;\n  font: inherit;\n  line-height: inherit;\n  color: inherit;\n  cursor: pointer;\n  outline: none;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var resetBtn = css(_templateObject$5());

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  border: none;\n  border-radius: 0;\n  background: none;\n  margin: 0;\n  padding: 0;\n  font: inherit;\n  line-height: inherit;\n  color: inherit;\n  outline: none;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var resetBtn$1 = css(_templateObject$6());

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Normalize background properties useful when changing
 * background image via server side on the actual html markup
 * @returns {CSS}
 */

var stdBackground = css(_templateObject$8());

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var Close = function Close(props) {
  return React.createElement(
    'svg',
    _extends({ width: '9', height: '9', viewBox: '0 0 9 9' }, props),
    React.createElement('path', { d: 'M4.5,3.09,7.29.29A1,1,0,0,1,8.71,1.71L5.91,4.5l2.8,2.79A1,1,0,0,1,7.29,8.71L4.5,5.91,1.71,8.71A1,1,0,0,1,.29,7.29L3.09,4.5.29,1.71A1,1,0,0,1,1.71.29Z' })
  );
};

var _templateObject$9 = taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n    transform: rotate(180deg);\n  '], ['\n    transform: rotate(180deg);\n  ']);

var Caret = function Caret(_ref) {
  var className = _ref.className;
  return React.createElement(
    'svg',
    { width: '15', height: '20', viewBox: '0 0 15 20', className: className },
    React.createElement(
      'defs',
      null,
      React.createElement('path', { id: 'b', d: 'M5 12l7.9 8 3.1-3.2-4.7-4.8L16 7.2 12.9 4z' }),
      React.createElement(
        'filter',
        { id: 'a', width: '154.5%', height: '137.5%', x: '-27.3%', y: '-18.8%', filterUnits: 'objectBoundingBox' },
        React.createElement('feOffset', { 'in': 'SourceAlpha', result: 'shadowOffsetOuter1' }),
        React.createElement('feGaussianBlur', { 'in': 'shadowOffsetOuter1', result: 'shadowBlurOuter1', stdDeviation: '1' }),
        React.createElement('feColorMatrix', { 'in': 'shadowBlurOuter1', values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.86175153 0' })
      )
    ),
    React.createElement(
      'g',
      { fill: 'none', transform: 'translate(-3 -2)' },
      React.createElement('use', { fill: '#000', filter: 'url(#a)', xlinkHref: '#b' }),
      React.createElement('use', { fill: '#FFF', xlinkHref: '#b' })
    )
  );
};

Caret.propTypes = {
  className: PropTypes.string
};

var CaretLeft = styled(Caret)(_templateObject$9, function (_ref2) {
  var rotated = _ref2.rotated;
  return rotated && css(_templateObject2$1);
});

var _templateObject$a = taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  z-index: ', ';\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 44px;\n  box-sizing: border-box;\n\n  *, *::before, *::after {\n    box-sizing: inherit;\n  }\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  z-index: ', ';\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 44px;\n  box-sizing: border-box;\n\n  *, *::before, *::after {\n    box-sizing: inherit;\n  }\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n  z-index: 2;\n  overflow: hidden;\n'], ['\n  z-index: 2;\n  overflow: hidden;\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n  height: 100%;\n  max-width: ', ';\n  margin: 0 auto;\n'], ['\n  height: 100%;\n  max-width: ', ';\n  margin: 0 auto;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n  background-color: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: -1;\n'], ['\n  background-color: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: -1;\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  ', ';\n  color: rgb(210, 210, 210);\n  background-color: rgb(22, 22, 23);\n  height: 44px;\n  width: 44px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  text-align: center;\n  display: flex;\n  transition: color 0.2s;\n  box-shadow: none;\n\n  &:hover, &:active, &:focus {\n    color: white;\n  }\n'], ['\n  ', ';\n  color: rgb(210, 210, 210);\n  background-color: rgb(22, 22, 23);\n  height: 44px;\n  width: 44px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  text-align: center;\n  display: flex;\n  transition: color 0.2s;\n  box-shadow: none;\n\n  &:hover, &:active, &:focus {\n    color: white;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  fill: currentColor;\n  margin: auto;\n'], ['\n  fill: currentColor;\n  margin: auto;\n']);

var Wrapper = styled.div(_templateObject$a, function (props) {
  return props.zOverride ? props.zOverride : '99999';
});

var OuterWrapper = styled.div(_templateObject2$2);

var InnerWrapper = styled.div(_templateObject3$1, function (_ref) {
  var maxWidth = _ref.maxWidth;
  return maxWidth || '800px';
});

var Background = styled.div(_templateObject4$1);

var CloseBtn = styled.button(_templateObject5, resetBtn);

var StyledClose = styled(Close)(_templateObject6);

var Overlay = function Overlay(_ref) {
  var dismiss = _ref.dismiss,
      children = _ref.children,
      noCloseBtn = _ref.noCloseBtn,
      maxWidth = _ref.maxWidth;
  return React.createElement(
    Wrapper,
    null,
    React.createElement(
      OuterWrapper,
      null,
      React.createElement(
        InnerWrapper,
        { maxWidth: maxWidth },
        children
      )
    ),
    React.createElement(
      Background,
      { onClick: dismiss },
      !noCloseBtn && React.createElement(
        CloseBtn,
        null,
        React.createElement(StyledClose, null)
      )
    )
  );
};

Overlay.propTypes = {
  dismiss: PropTypes.func,
  children: PropTypes.node.isRequired,
  noCloseBtn: PropTypes.bool,
  maxWidth: PropTypes.number
};

var ImageLazyLoader = function (_Component) {
  inherits(ImageLazyLoader, _Component);

  function ImageLazyLoader() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ImageLazyLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ImageLazyLoader.__proto__ || Object.getPrototypeOf(ImageLazyLoader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      images: []
    }, _this.getNextImg = function () {
      var _this$props = _this.props,
          src = _this$props.src,
          index = _this$props.index;

      var potentialNext = index + 1;
      var realNext = potentialNext <= src.length - 1 ? potentialNext : 0;
      var nextImg = src[realNext];
      return nextImg;
    }, _this.getPrevImg = function () {
      var _this$props2 = _this.props,
          src = _this$props2.src,
          index = _this$props2.index;

      var potentialPrev = index - 1;
      var realPrev = potentialPrev >= 0 ? potentialPrev : src.length - 1;
      var prevImg = src[realPrev];
      return prevImg;
    }, _this.fetchImages = function () {
      var _this2 = _this,
          getNextImg = _this2.getNextImg,
          getPrevImg = _this2.getPrevImg;


      var images = [getPrevImg(), getNextImg()];

      _this.setState({ images: images });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ImageLazyLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchImages();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var prevIndex = prevProps.index;
      var index = this.props.index;

      if (prevIndex !== index) {
        this.fetchImages();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          src = _props.src,
          index = _props.index;
      var images = this.state.images;

      var passedProps = {
        images: images, currentImage: src[index]
      };
      return children(passedProps);
    }
  }]);
  return ImageLazyLoader;
}(Component);

ImageLazyLoader.propTypes = {
  src: srcArray,
  index: PropTypes.number.isRequired,
  children: PropTypes.func.isRequired
};

var _templateObject$b = taggedTemplateLiteral(['\n  position: relative;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n'], ['\n  position: relative;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n  ', '\n  position: absolute;\n  height: 100%;\n  width: 40%;\n  top: 0;\n  ', ': 0;\n  display: flex;\n  transition: opacity 0.2s;\n  box-shadow: none;\n\n  @media (min-width: 1024px) {\n    opacity: 0;\n    background-image: linear-gradient(\n      to ', ',\n      rgba(0, 0, 0, 0.7) -20%, rgba(0, 0, 0, 0.01)\n    );\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n\n  svg {\n    fill: currentColor;\n    margin: auto;\n  }\n'], ['\n  ', '\n  position: absolute;\n  height: 100%;\n  width: 40%;\n  top: 0;\n  ', ': 0;\n  display: flex;\n  transition: opacity 0.2s;\n  box-shadow: none;\n\n  @media (min-width: 1024px) {\n    opacity: 0;\n    background-image: linear-gradient(\n      to ', ',\n      rgba(0, 0, 0, 0.7) -20%, rgba(0, 0, 0, 0.01)\n    );\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n\n  svg {\n    fill: currentColor;\n    margin: auto;\n  }\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n  display: block;\n  margin: 0 auto;\n  max-width: 100%;\n  max-height: 100%;\n'], ['\n  display: block;\n  margin: 0 auto;\n  max-width: 100%;\n  max-height: 100%;\n']),
    _templateObject4$2 = taggedTemplateLiteral(['\n  visibility: hidden;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n'], ['\n  visibility: hidden;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n']);

var ImagesWrapper = styled.div(_templateObject$b);

var Btn = styled.button(_templateObject2$3, resetBtn, function (_ref) {
  var left = _ref.left;
  return left ? 'left' : 'right';
}, function (_ref2) {
  var left = _ref2.left;
  return left ? 'right' : 'left';
});

var Image = styled.img(_templateObject3$2);

var PreloadWrapper = styled.div(_templateObject4$2);

var Markup = function Markup(_ref) {
  var showPortal = _ref.showPortal,
      toggleOpen = _ref.toggleOpen,
      index = _ref.index,
      next = _ref.next,
      previous = _ref.previous,
      currentImage = _ref.currentImage,
      images = _ref.images,
      manyPics = _ref.manyPics,
      maxWidth = _ref.maxWidth;

  if (!showPortal) return false;
  return React.createElement(
    Portal,
    null,
    React.createElement(
      Overlay,
      { dismiss: toggleOpen, maxWidth: maxWidth },
      React.createElement(
        ImagesWrapper,
        null,
        manyPics && React.createElement(
          Btn,
          { left: true, onClick: previous },
          React.createElement(CaretLeft, null)
        ),
        React.createElement(Image, { src: currentImage.url }),
        manyPics && React.createElement(
          Btn,
          { onClick: next },
          React.createElement(CaretLeft, { rotated: true })
        ),
        images && React.createElement(
          PreloadWrapper,
          null,
          images.map(function (i, k) {
            return React.createElement(Image, { key: k, src: i.url });
          })
        )
      )
    )
  );
};

Markup.propTypes = {
  showPortal: PropTypes.bool.isRequired,
  currentImage: srcShape,
  images: srcArray,
  toggleOpen: PropTypes.func,
  index: PropTypes.number,
  previous: PropTypes.func,
  manyPics: PropTypes.bool,
  next: PropTypes.func,
  maxWidth: PropTypes.number
};

var Lightbox = function (_Component) {
  inherits(Lightbox, _Component);

  function Lightbox() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Lightbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Lightbox.__proto__ || Object.getPrototypeOf(Lightbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showPortal: !!_this.props.open,
      index: 0
    }, _this.toggleOpen = function () {
      var showPortal = _this.state.showPortal;
      var _this2 = _this,
          open = _this2.open,
          close = _this2.close;

      if (showPortal) {
        close();
      } else {
        open();
      }
    }, _this.openByIndex = function (index) {
      return function () {
        _this.setState({ index: index });
        _this.open();
      };
    }, _this.open = function () {
      _this.setState({
        showPortal: true
      });
      _this.listen();
    }, _this.close = function () {
      _this.setState({
        showPortal: false
      });
      _this.unlisten();
    }, _this.listen = function () {
      document.addEventListener('keydown', _this.handleKeydown);
      document.querySelector('*').addEventListener('mousemove', _this.handleMousemove);
      noScroll.on();
    }, _this.unlisten = function () {
      document.removeEventListener('keydown', _this.handleKeydown);
      document.querySelector('*').removeEventListener('mousemove', _this.handleMousemove);
      noScroll.off();
    }, _this.handleKeydown = function (e) {
      var LEFT = 37;
      var RIGHT = 39;
      var ESC = 27;
      var keyCode = e.keyCode;


      if (keyCode === LEFT && _this.props.keyboardNavigation) {
        _this.previous();
      } else if (keyCode === RIGHT && _this.props.keyboardNavigation) {
        _this.next();
      } else if (keyCode === ESC && _this.props.closeOnEsc) {
        _this.close();
      }
    }, _this.previous = function () {
      var index = _this.state.index;
      var src = _this.props.src;

      var potentialPrev = index - 1;
      var realPrev = potentialPrev >= 0 ? potentialPrev : src.length - 1;
      if (realPrev !== index) {
        _this.setState({
          index: realPrev
        });
      }
    }, _this.next = function () {
      var index = _this.state.index;
      var src = _this.props.src;

      var potentialNext = index + 1;
      var realNext = potentialNext <= src.length - 1 ? potentialNext : 0;
      if (realNext !== index) {
        _this.setState({
          index: realNext
        });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Lightbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.open) {
        this.open();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.open && nextProps.open) {
        this.open();
      }
      if (this.props.open && !nextProps.open) {
        this.close();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.open) {
        this.close();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var markupProps = _extends({}, this.state, {
        toggleOpen: this.toggleOpen,
        next: this.next,
        previous: this.previous,
        manyPics: this.props.src.length > 1,
        maxWidth: this.props.maxWidth
      });

      var childProps = _extends({}, this.state, {
        toggleOpen: this.toggleOpen,
        openByIndex: this.openByIndex
      });

      var lazyLoaderProps = {
        index: this.state.index,
        src: this.props.src
      };

      var children = this.props.children;


      return React.createElement(
        Fragment,
        null,
        React.createElement(
          ImageLazyLoader,
          lazyLoaderProps,
          function (_ref2) {
            var currentImage = _ref2.currentImage,
                images = _ref2.images;
            return React.createElement(Markup, _extends({}, markupProps, {
              currentImage: currentImage,
              images: images
            }));
          }
        ),
        children(childProps)
      );
    }
  }]);
  return Lightbox;
}(Component);

Lightbox.propTypes = {
  open: PropTypes.bool,
  src: srcArray,
  closeOnEsc: PropTypes.bool,
  keyboardNavigation: PropTypes.bool,
  children: PropTypes.func.isRequired,
  maxWidth: PropTypes.number
};
Lightbox.defaultProps = {
  closeOnEsc: true,
  keyboardNavigation: true
};

export default Lightbox;
//# sourceMappingURL=index.es.js.map
